module.exports = new __parcel__URL__("ScrollLogo.6da344f7.svg").toString();